import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import LogAdaptativoList from './logAdaptativoList';

import { getLog } from './logAdaptativoActions';
import { selectTab, showTabs } from '../common/tab/tabActions';

class LogAdaptativo extends Component {
  constructor(props) {
    super(props);
    this.state = { agrupador: 0 }; // 0 = Sem agrupamento (padrão)
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentWillMount() {
    this.props.showTabs('tabList');
    this.props.selectTab('tabList');
    this.props.getLog(this.state.agrupador);
  }

  // Função para lidar com mudança de filtros (controlador ou agrupamento)
  handleFilterChange = e => {
    const agrupador = e.target ? e.target.value : this.state.agrupador;
    if (e.target && e.target.id === 'agrupador') {
      this.setState({ agrupador: parseInt(agrupador) });
    }

    // Aguarda um pequeno delay para garantir que a configuração foi atualizada
    setTimeout(() => {
      this.props.getLog(e.target && e.target.id === 'agrupador' ? parseInt(agrupador) : this.state.agrupador);
    }, 100);
  };

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico
                    onChange={this.handleFilterChange}
                    emptyText="Todos"
                    customStyle={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  />
                  <SelectConfControlador
                    anel={false}
                    onChange={this.handleFilterChange}
                    emptyText="Todos"
                    customStyle={{
                      width: '260px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    htmlFor="agrupador"
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                    }}
                  >
                    Agrupar:
                  </label>
                  <select
                    id="agrupador"
                    className="form-control"
                    style={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                    value={this.state.agrupador}
                    onChange={this.handleFilterChange}
                  >
                    <option value="0">Sem agrupamento</option>
                    <option value="5">5 min</option>
                    <option value="10">10 min</option>
                    <option value="15">15 min</option>
                    <option value="30">30 min</option>
                    <option value="60">60 min</option>
                  </select>
                </div>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <LogAdaptativoList agrupador={this.state.agrupador} />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getLog, selectTab, showTabs }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(LogAdaptativo);
